import { motion } from "framer-motion";
import { StageTimeline } from "../shared/StageTimeline";
import { formatET } from "../../lib/dateUtils";

const STAGES = ["Pipeline", "Submitted", "Underwriting", "Approved", "Funded"];

export function YourIGCDashboard({ data }) {
  if (!data) return null;
  const currentStage = STAGES.includes(data.current_stage) ? data.current_stage : "Pipeline";

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="bg-igc-surface border border-igc-gold/30 p-8 mb-8" data-testid="your-igc-dashboard">
      <p className="text-igc-goldText text-xs uppercase tracking-widest mb-1" title="A live view of your Business Funding deal moving through IGC's pipeline, from submission to funded.">Your IGC Dashboard</p>
      <h2 className="font-serif text-2xl text-igc-cream mb-6">A real-time view of your funding journey</h2>

      <div className="mb-8">
        <StageTimeline stages={STAGES} currentStage={currentStage} testId="your-igc-dashboard-stage-timeline" />
      </div>

      <div className="grid grid-cols-3 gap-4 mb-8">
        <div className="bg-igc-surfaceLight p-4" data-testid="your-igc-dashboard-projected">
          <p className="text-igc-muted text-[10px] uppercase tracking-widest mb-1" title="What your commission could be if this deal closes.">Projected</p>
          <p className="font-serif text-xl text-igc-cream">${(data.commission_projected || 0).toLocaleString()}</p>
        </div>
        <div className="bg-igc-surfaceLight p-4" data-testid="your-igc-dashboard-pending">
          <p className="text-igc-muted text-[10px] uppercase tracking-widest mb-1" title="Commission awaiting a final decision.">Pending</p>
          <p className="font-serif text-xl text-igc-goldText">${(data.commission_pending || 0).toLocaleString()}</p>
        </div>
        <div className="bg-igc-surfaceLight p-4" data-testid="your-igc-dashboard-confirmed">
          <p className="text-igc-muted text-[10px] uppercase tracking-widest mb-1" title="Commission already confirmed and owed to you.">Confirmed</p>
          <p className="font-serif text-xl text-igc-success">${(data.commission_confirmed || 0).toLocaleString()}</p>
        </div>
      </div>

      {data.activity_timeline?.length > 0 && (
        <div>
          <p className="text-igc-muted text-[10px] uppercase tracking-widest mb-3" title="Every status change on your deal, in order.">Activity Timeline</p>
          <div className="border-l-2 border-igc-gold/30 pl-4 space-y-2">
            {data.activity_timeline.map((t, i) => (
              <p key={i} className="text-igc-muted text-xs" data-testid={`your-igc-dashboard-timeline-item-${i}`}>
                <span className="text-igc-goldText">{t.deal_name}</span> — {t.status} — {formatET(t.changed_at, "MMM d, yyyy h:mm a")}
              </p>
            ))}
          </div>
        </div>
      )}
    </motion.div>
  );
}
